<section *removeIfNoPermission="canImport">
  <h1>Import Events</h1>
  <ng-container *ngIf="eventImportTemplate$ | async as templateLink">
    <button class="btn btn-link p-0" (click)="onClickDownload(templateLink)"><i aria-hidden="true" class="fas fa-file-download"></i> Download the template to bulk upload RMS data into the system.</button>
    <p class="my-2 fst-italic"><small>Note: Last updated on {{ templateLink.CreatedOn | utcToLocal:'MM/dd/yyyy  HH:mm' }}</small></p>
    <a aria-hidden="true" class="d-none" [download]="templateLink.FileName" #downloadTemplateLink></a>
  </ng-container>
  <div *ngIf="fileTransferSucceeded" class="my-3">
    <div class="alert alert-success alert-dismissible fade show" role="alert">
      <i class="fas fa-check-circle" aria-hidden="true"></i> <strong class="mx-2">Import processing started.</strong>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  </div>
  <div class="my-3">
    <p-fileUpload id="BulkEventUpload" name="myfile[]" url="{{apiRoot}}/api/Events/BulkEventUpload?utcoffset={{utcoffset}}" (onUpload)="onUploadHandler($event)"></p-fileUpload>
  </div>
  <div class="my-3">
    <p-table [value]="importResults" [columns]="cols" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll">
      <ng-template pTemplate="caption">
        <div class="d-flex justify-content-end">
          <button #collapseBtn (click)="toggleIcon($event)" class="btn btn-link btn-sm" type="button" data-bs-toggle="collapse" data-bs-target="#importStatus" aria-expanded="true" aria-controls="importStatus" aria-label="Expand or collapse import status details"><i class="fas {{iconClass}} fa-2x text-primary" title="{{iconClass == 'fa-caret-left' ?  'Expand' : 'Collapse'}} import status"></i></button>
        </div>
        <div id="importStatus" class="collapse show p-2">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="fw-bold">Import Status as of {{ currentDateTime | date:'MM/dd/yyyy  HH:mm:ss' }}</div>
            <button type="button" (click)="refreshStatus()" class="btn btn-success btn-sm ">Refresh Status</button>
          </div>
          <div class="font-size-sm max-vh-25 overflow-y-auto">
            <div *ngFor="let import of importStatus">{{import.FileName}} started at {{import.UploadStarted  | utcToLocal:'MM/dd/yyyy  HH:mm'}} <ng-container *ngIf="!import.UploadCompleted">{{import.ProcessedRecordCount}} of {{import.TotalRecordCount}} items processed.</ng-container><ng-container *ngIf="import.UploadCompleted"> and completed on {{import.UploadCompleted | utcToLocal:'MM/dd/yyyy  HH:mm' }} with total {{import.TotalRecordCount}} items and {{import.ErrorCount}} error(s)</ng-container></div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr><th scope="colgroup" colspan="5" class="bg-warning">Failed Import Items</th></tr>
        <tr>
          <th scope="col" *ngFor="let col of columns">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-import let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <th scope="row" *ngIf="col.field=='ItemUploadDateTime';else tddefault">{{ import[col.field] | utcToLocal:'MM/dd/yyyy HH:mm'}}</th>
            <ng-template #tddefault>
              <td [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'LECaseID'"><a  role="button" tabindex="0" aria-label="{{'Case '+import.LECaseID+' details'}}" (click)="viewEvent(import)">{{ import[col.field]}}</a></ng-container>
                <ng-container *ngSwitchCase="'CrimeType'"><div class="wrap-break-word">{{import[col.field]}}</div></ng-container>
                <ng-container *ngSwitchDefault>{{import[col.field]}}</ng-container>
              </td>
            </ng-template>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No failed import items found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
<aside>
  <p-sidebar [(visible)]="openViewEventForm" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
    <ness-event-detail #eventDetail (showEventDetail)="openViewEventForm = false" [event]="event" [crimeTypeName]="crimeTypeName" [importItemId]="importItemId" [hasEditPermission]="true"></ness-event-detail>
  </p-sidebar>
</aside>
